module.exports = __webpack_public_path__ + "static/dcg_logo-2e1a8e5c2a1c7c55c781d4e2ce4f7493.png";